var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"containner",staticClass:"confetti-container"},[_c('canvas',{attrs:{"id":'confettiCanvas_' + _vm.canvasId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }